export enum CurrentJobEnum {
  NO = 'no',
  YES_ONE_JOB = 'yes_one_job',
  YES_TWO_JOBS = 'yes_two_jobs',
}